// **** External Utilities ****
import axios from 'axios';

import apiService from '../../../services/api.service';
import { checkPermission } from '../../../utils/Helpers';
import { getQuoteById, putTurnOnTime } from '../../CRM/Quotes/helpers/Quotes';
import {
  CONFIG,
  REQUIRED_USER_FIELDS,
  SOURCE_SYSTEMS,
} from '../../../constants';
import { URL_CONSTANTS } from '../../../constants/urlConstants';
import permissions from '../../../config/permissions';
import { ERROR_CODES } from '../../../constants/errorCode.constant';
import { retryPromise } from '../../../utils/retry.helper';

import { PROJECT_NUMBER_API_ERROR_MSG } from './constants';
export const getSMSNotifications = async (
  setSMSLoading,
  setNotificationsList,
  offset,
  limit,
  setSmsCount
) => {
  try {
    setSMSLoading(true);
    let smsDetailsRequest = {};

    if (
      checkPermission(permissions.pullDownMenu.view) &&
      checkPermission(permissions?.pullDownMenu?.smsVisibilityNotes)
    ) {
      smsDetailsRequest = await axios.get(
        `${URL_CONSTANTS.API.BASE_URL}/projects/reports/sms?offset=${offset}&limit=${limit}`
      );
    }

    setSmsCount(smsDetailsRequest?.data?.count);
    if (smsDetailsRequest?.data) {
      const newNotificationList = [];
      if (smsDetailsRequest?.data) {
        newNotificationList.push(...(smsDetailsRequest.data?.smsList || []));
      }
      setNotificationsList(newNotificationList);
    }
  } catch (error) {
    console.log(error);
  } finally {
    setSMSLoading(false);
  }
};

export const getEmailNotifications = async (
  setEmailLoading,
  setEmailList,
  offset,
  limit,
  setEmailCount
) => {
  try {
    setEmailLoading(true);
    let response = {};
    if (
      checkPermission(permissions.pullDownMenu.view) &&
      checkPermission(permissions?.pullDownMenu?.emailVisibilityNotes)
    ) {
      response = await axios.get(
        `${URL_CONSTANTS.API.BASE_URL}/email/manage/user?offset=${offset}&limit=${limit}`
      );
    }

    setEmailCount(response?.data?.count);
    if (response?.data && response?.data?.items?.length) {
      const newEmailList = [];
      if (response?.data?.items) {
        newEmailList.push(...response.data.items);
      }
      setEmailList(newEmailList);
    }
  } catch (error) {
    console.log(error);
  } finally {
    setEmailLoading(false);
  }
};
export const getStoreNotifications = async (
  setStoreLoading,
  setStoreNotificationsList,
  offset,
  limit,
  setStoreCount
) => {
  try {
    setStoreLoading(true);
    let response = {};
    if (
      checkPermission(permissions.pullDownMenu.view) &&
      checkPermission(permissions?.pullDownMenu?.storeVisibilityNotes)
    ) {
      response = await axios.get(
        `${URL_CONSTANTS.API.BASE_URL}/projects/notes/store?offset=${offset}&limit=${limit}`
      );
    }

    setStoreCount(response?.data?.count);
    if (response?.data && response?.data?.storeItems?.length) {
      const newStoreList = [];
      if (response?.data?.storeItems) {
        newStoreList.push(...response.data.storeItems);
      }
      setStoreNotificationsList(newStoreList);
    }
  } catch (error) {
    console.log(error);
  } finally {
    setStoreLoading(false);
  }
};

export const getInstallerNotifications = async (
  setInstallerLoading,
  setInstallerNotificationsList,
  offset,
  limit,
  installerNotificationsList,
  setShowInstallerLoadMore,
  setTotalInstallerNotificationCount
) => {
  try {
    setInstallerLoading(true);
    let response = {};
    if (
      checkPermission(permissions.pullDownMenu.view) &&
      checkPermission(permissions?.pullDownMenu?.installerVisibilityNotes)
    ) {
      response = await axios.get(
        `${URL_CONSTANTS.API.BASE_URL}/projects/notes/installer?offset=${offset}&limit=${limit}`
      );
    }

    setTotalInstallerNotificationCount(response?.data?.count);

    if (response?.data && response?.data?.installerItems?.length) {
      const newInstallerList = [];
      if (response?.data?.installerItems) {
        newInstallerList.push(...response.data.installerItems);
      }

      setInstallerNotificationsList(newInstallerList);
      if (response?.data?.installerItems.length < limit) {
        setShowInstallerLoadMore(false);
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    setInstallerLoading(false);
  }
};

export const getCustomerNotesNotifications = async (
  setCustomerLoading,
  setCustomerNotesList,
  offset,
  limit,
  setCustomerNotesLoadMore,
  setCustomerNotesCount
) => {
  try {
    setCustomerLoading();
    let response = {};
    if (
      checkPermission(permissions.pullDownMenu.view) &&
      checkPermission(permissions.pullDownMenu.customerNotes)
    ) {
      response = await axios.get(
        `${URL_CONSTANTS.API.BASE_URL}/projects/notes/customernotes?offset=${offset}&limit=${limit}`
      );
    }

    setCustomerNotesCount(response?.data?.count);

    if (response?.data && response?.data?.installerItems?.length) {
      const newInstallerList = [];
      if (response?.data?.installerItems) {
        newInstallerList.push(...response.data.installerItems);
      }

      setCustomerNotesList(newInstallerList);
      if (response?.data?.installerItems.length < limit) {
        setCustomerNotesLoadMore(false);
      }
    }
  } catch (error) {
    console.log(error);
  } finally {
    setCustomerLoading(false);
  }
};

export const storeReviewRead = async (noteId, type = 'review', userId) => {
  try {
    await axios.post(
      `${URL_CONSTANTS.API.BASE_URL}/projects/notes/store/${noteId}/${type}`,
      {
        userId,
        type: 'store',
      }
    );
  } catch (error) {
    console.log('Review Store Error', error);
  }
};

export const installerReviewRead = async (noteId, type = 'review', userId) => {
  try {
    await axios.post(
      `${URL_CONSTANTS.API.BASE_URL}/projects/notes/installer/${noteId}/${type}`,
      {
        userId,
        type: 'store',
      }
    );
  } catch (error) {
    console.log('Review Installer Error', error);
  }
};

export const customerNotesReviewRead = async (
  noteId,
  type = 'review',
  userId
) => {
  try {
    await axios.post(
      `${URL_CONSTANTS.API.BASE_URL}/projects/notes/customernotes/${noteId}/${type}`,
      {
        userId,
        type: 'customer_note',
      }
    );
  } catch (error) {
    console.log('Review Customer Note Error', error);
  }
};
// Get Project Details by Id
export const getProjectById = async (
  projectId,
  setLoading,
  setAlert,
  setProjectDetailsData,
  setStoreDetails = () => {},
  setCustomerDetails = () => {},
  setReportStatusDetails = () => {},
  setAllUserList = () => {},
  unAuthorizedAccessHandler = () => {}
) => {
  try {
    setLoading(true);
    const responses = await retryPromise(
      async () => {
        const projectDetailsRequest = axios.get(
          `${URL_CONSTANTS.API.BASE_URL}/projects/${projectId}`
        );

        const storeDetailsRequest = axios.get(
          `${URL_CONSTANTS.API.BASE_URL}/stores/reports/project-store-details/${projectId}`
        );

        return await Promise.all([projectDetailsRequest, storeDetailsRequest]);
      },
      3,
      1000
    ); // 3 retries with 1 second base delay

    if (responses[0]?.data?.customer_id) {
      getCustomerDetails(
        responses[0]?.data?.customer_id,
        setLoading,
        setCustomerDetails,
        ''
      );
    }

    setReportStatusDetails({
      name: responses[0]?.data?.status?.status,
      status_id: responses[0]?.data?.status?.status_id,
    });
    setProjectDetailsData(responses[0]?.data);
    setStoreDetails(responses[1]?.data);
    if (
      responses[0]?.data?.project_additional_fields?.related_measurer_id?.email
    ) {
      const response = await searchUserList(
        responses[0]?.data?.project_additional_fields?.related_measurer_id
          ?.email
      );
      if (response) {
        setAllUserList(response);
      }
    }
  } catch (error) {
    if (error?.response?.status == ERROR_CODES.FORBIDDEN) {
      unAuthorizedAccessHandler();
    } else {
      setAlert('error', 'Error in Fetching Project Details.');
    }
  } finally {
    setLoading(false);
  }
};

export const getUnpaidChargebackCountByProjectID = async projectId => {
  try {
    if (!projectId) return null;
    const response = await apiService.getWithDiffBaseUrl(
      `${URL_CONSTANTS.CHARGEBACK.chargebackSummary.getChargeback}/unpaid/${projectId}`,
      {},
      URL_CONSTANTS.CHARGEBACK.baseUrl
    );

    return response?.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

// Get Project Type dropdown options
export const getUserProfile = async (setUserProfile, hasRetried = false) => {
  try {
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/auth/user/profile`
    );

    const hasMissingFields = REQUIRED_USER_FIELDS?.some(
      field => response?.data?.[field] === undefined
    );

    if ((response?.data?.status === false || hasMissingFields) && !hasRetried) {
      return getUserProfile(setUserProfile, true);
    }
    setUserProfile(response?.data);
    localStorage.setItem(
      'logged_in_user',
      `${response?.data?.first_name} ${response?.data?.last_name}`
    );
    localStorage.setItem('installer_id', response?.data?.installer_id);
    localStorage.setItem('role_name', response?.data?.role_name);
    localStorage.setItem('role_id', response?.data?.role_id);
    localStorage.setItem('is_installer', response?.data?.is_installer);
    localStorage.setItem(
      'userInfo',
      JSON.stringify({
        userWorkroom_id: response?.data?.workroom_ids,
        userWorkroom_name: response?.data?.workroom_names,
        userTeam_id: response?.data?.team_id,
        userTeam_name: response?.data?.team_name,
        fullname: response?.data?.fullname,
        email: response?.data?.email,
        contact_no: response?.data?.contact_no,
        user_id: response?.data?.user_id,
      })
    );

    if (!localStorage.getItem('scheduler_card_view')) {
      localStorage.setItem('scheduler_card_view', false);
    }
    return response?.data;
  } catch (error) {
    console.log(error);
  }
};
let controller;
// Get Project Type dropdown options
export const searchProjects = async (
  searchStringVal,
  searchParameter,
  redirectionMethod,
  history,
  setOptions,
  searchSuggession,
  setIsHardRefresh,
  setGlobalSearchLoader
) => {
  if (controller) {
    controller.abort();
  }
  controller = new AbortController();
  const pathName = window.location.pathname;
  const segments = pathName.split('/');
  let redirectPath = null;
  if (segments[1] === 'crm') {
    redirectPath = `/crm/${segments[2]}/${segments[3]}/project/view/${
      segments[segments.length - 1]
    }`;
  }
  let url;
  let query;
  let additionalParams = '';
  if (setGlobalSearchLoader) setGlobalSearchLoader(true);
  switch (searchParameter) {
    case 'project_number':
      url = 'projects/v1/search-by-project-number';
      query = 'project_number';
      additionalParams += `&is_suggestion_enabled=${searchSuggession}`;
      break;
    case 'po_number':
      url = 'projects/v1/search-by-po-number';
      query = 'po_number';
      additionalParams += `&is_suggestion_enabled=${searchSuggession}`;
      break;
    case 'client':
      url = 'customers/report/search-by-name';
      query = 'searchString';
      additionalParams += '&offset=0&limit=20';
      break;
    case 'phone':
      url = 'customers/report/search-by-phone-number';
      query = 'searchString';
      break;
    case 'address':
      url = 'projects/search-by-address';
      query = 'k';
      break;
  }

  if (searchStringVal) {
    try {
      if (setGlobalSearchLoader) setGlobalSearchLoader(true);
      const response = await axios.get(
        `${URL_CONSTANTS.API.BASE_URL}/${url}?${query}=${searchStringVal}${additionalParams}`,
        {
          signal: controller.signal,
        }
      );
      if (response?.data && response?.data?.length && !searchSuggession) {
        if (
          searchParameter === 'project_number' ||
          searchParameter === 'po_number'
        ) {
          let projectId = null;
          if (response.data.length === 1) {
            projectId = response.data[0].project_id;
          } else {
            projectId = response.data.find(
              record =>
                parseInt(searchStringVal) == parseInt(record.project_number)
            )?.project_id;
          }
          if (projectId) {
            const redirection = redirectPath
              ? redirectPath
              : `/project/view/${projectId}`;
            history.push(
              `${redirection}/#tab=scheduleInfo?searchType=${searchParameter}&searchValue=${searchStringVal}`
            );
          }
        }
      }
      let data = response.data;
      if (
        !['project_number', 'po_number', 'address'].includes(searchParameter)
      ) {
        data = data.items;
      }
      if (setIsHardRefresh) setIsHardRefresh(Math.random());
      if (setGlobalSearchLoader) setGlobalSearchLoader(false);
      return data;
    } catch (error) {
      console.error(error);
      if (setGlobalSearchLoader) setGlobalSearchLoader(false);
    }
  }
};

export const searchCustomers = async searchString => {
  try {
    if (searchString) {
      const response = await axios.get(
        `${URL_CONSTANTS.API.BASE_URL}/customers?searchString=${searchString}&offset=0&limit=10`
      );
      return response?.data;
    }
  } catch (error) {
    console.error(error);
  }
};

// Get Project Type, Category, Source, Customers dropdown options
export const getDropdownValues = async (
  setLoading,
  setProjectTypeOptions,
  setCustomerOptions,
  setStoreOptions,
  setInitialCustomerOptions,
  setReferralSourceOptions
) => {
  try {
    setLoading(true);

    const projectTypeRequest = axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/projects/master/project-type`
    );
    const customerRequest = axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/customers`
    );
    const storeRequest = axios.get(`${URL_CONSTANTS.API.BASE_URL}/stores`);
    const referralSourceName = axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/system/referral-source`
    );

    const responses = await Promise.all([
      projectTypeRequest,
      customerRequest,
      storeRequest,
      referralSourceName,
    ]);

    setProjectTypeOptions(responses[0]?.data);
    setCustomerOptions(responses[1]?.data);
    setStoreOptions(responses[2]?.data);
    setInitialCustomerOptions(responses[1]?.data);
    setReferralSourceOptions(responses[3]?.data);
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};
// Get Store Details by store id
export const getStoreDetailsByStoreId = async (storeId, setStoreDetails) => {
  try {
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/stores/${storeId}`
    );
    setStoreDetails(response?.data);
  } catch (error) {
    console.log(error);
  }
};

export const addNewCategory = async (
  categoryName,
  setNewCategoryLoading,
  setNewCategoryError,
  setCategoryPopupOpen,
  setCategoryOptions,
  clearMasterData,
  fetchMasterData
) => {
  try {
    setNewCategoryLoading(true);
    const response = await apiService.post(
      `/projects/master/project-category`,
      {
        category: categoryName,
      }
    );
    if (response) {
      setCategoryOptions(response);
      setCategoryPopupOpen(false);
      clearMasterData();
      fetchMasterData();
    }
  } catch (error) {
    console.log(error);
    if (error?.response?.status === 422) {
      setNewCategoryError(
        'This category already exists, please try again with a different name.'
      );
    } else {
      setNewCategoryError(
        'Something went wrong, please try again after sometime.'
      );
    }
  } finally {
    setNewCategoryLoading(false);
  }
};

// Get Customer's Address
export const getCustomerAddress = async (
  billingAddressId,
  setCustomerAddress
) => {
  try {
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/system/address/${billingAddressId}`
    );
    setCustomerAddress(response?.data);
  } catch (error) {
    console.log(error);
  }
};

// Get Status dropdown options
export const getStatusOptions = async (
  statusType,
  setLoading,
  setStatusOptions
) => {
  try {
    setLoading(true);
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/system/status?statusType=${statusType}`
    );
    let statusOptions = response.data;
    const isTentativeSchedulingEnabled =
      localStorage.getItem('isTentativeSchedulingEnabled') === 'true'
        ? true
        : false;
    if (!isTentativeSchedulingEnabled) {
      statusOptions = statusOptions?.filter(
        item => item.status !== 'Tentatively Scheduled'
      );
    }
    setStatusOptions(statusOptions);
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

// Update Project Details
export const updateProject = async (
  projectId,
  updateObj,
  history,
  setReloadForm,
  setLoading,
  setAlert,
  redirectBasePath,
  toast = null
) => {
  try {
    let updateRequestObj = {
      total_sale_amount: updateObj?.total_sale_amount || null,
      confirmation_status_id: updateObj?.confirmation_status?.status_id,
      source_system_id: updateObj?.source_system?.source_system_id,
      customer_id: updateObj?.customer?.customer_id,
      store_id: updateObj?.store_id,
      po_number: updateObj?.po_number,
      quote_number: updateObj?.quote_number,
      work_order_number: updateObj?.work_order_number,
      date_sold: updateObj?.date_sold,
      status_id: updateObj?.status?.status_id,
      project_desc: updateObj?.project_desc?.trim() || null,
      project_type_id: updateObj?.project_type?.project_type_id,
      project_category_id: updateObj?.project_category_id,
      source_category_id: updateObj?.source_category_id,
      reschedule_reason_id: updateObj?.reschedule_reason?.reason_id,
      date_scheduled_start: updateObj?.date_scheduled_start,
      date_scheduled_end: updateObj?.date_scheduled_end,
      completion_date: updateObj?.completion_date,
      windows: updateObj?.windows,
      rts_follow_up_date: updateObj?.rts_follow_up_date,
      pick_up_date: updateObj?.pick_up_date,
      pick_up_location_id: updateObj?.pick_up_location_id,
      primary_pick_up_location: updateObj?.primary_pick_up_location?.name
        ? updateObj?.primary_pick_up_location?.name
        : '',
      pick_up_location_reference_address_id:
        updateObj?.pick_up_location_reference_address_id,
      open_in_provider_portal: updateObj?.open_in_provider_portal,
      epa_add_lead_safe_practices_item:
        updateObj?.epa_add_lead_safe_practices_item,
      epa_lead_response_reason_id: updateObj?.epa_lead_response_reason_id,
      epa_override_reason_code_id: updateObj?.epa_override_reason_code_id,
      epa_is_renovator_certified: updateObj?.epa_is_renovator_certified,
      epa_is_lead_assessment_docs_submitted:
        updateObj?.epa_is_lead_assessment_docs_submitted,
      epa_lead_assessment_required: updateObj?.epa_lead_assessment_required,
      epa_lead_remediation: updateObj?.epa_lead_remediation,
      epa_job_id: updateObj?.epa_job_id,
      epa_lead_test_result_id: updateObj?.epa_lead_test_result_id,
      epa_remove_override: updateObj?.epa_remove_override,
      epa_permit_required: updateObj?.epa_permit_required,
      epa_permit_number: updateObj?.epa_permit_number,
      installation_address: [{ ...updateObj?.installation_address }],
      installer_reference: updateObj?.installer_reference,
      meta: updateObj?.meta || {},
      scheduled_date_811: updateObj?.scheduled_date_811 || null,
      is_pull_permit_required: updateObj?.is_pull_permit_required ? 1 : 0,
      hd_category: updateObj?.hd_category || null,
      tier: updateObj?.tier || null,
      est_job_duration: updateObj?.est_job_duration?.toString() || null,
      pickup_required: updateObj?.pickup_required,
      products: updateObj?.products === '' ? null : updateObj?.products,
      year_built: updateObj?.year_built?.toString() || null,
      pick_up_location_address_id:
        updateObj?.pick_up_location_address_id || null,
      manage_as_project: updateObj?.manage_as_project,
      measure_to_install_conversion_rate:
        updateObj?.measure_to_install_conversion_rate ?? 0,
      move_up_on_schedule:
        updateObj?.move_up_on_schedule === 1 ? true : false || false,
      referral_source_id: updateObj?.referral_source_id || null,
      scheduling_reason: updateObj?.scheduling_reason?.label
        ? updateObj?.scheduling_reason?.label
        : updateObj?.scheduling_reason || null,
      schedule_pending_reason: updateObj?.schedule_pending_reason?.label
        ? updateObj?.schedule_pending_reason?.label
        : updateObj?.schedule_pending_reason || null,
      related_measurer: updateObj?.related_measurer || null,
      eta_date: updateObj?.eta_date || null,
      ll_invoice_status: updateObj?.ll_invoice_status || null,
      ll_invoice_sent_date: updateObj?.ll_invoice_sent_date || null,
      ll_pgi_invoice_date: updateObj?.ll_pgi_invoice_date || null,
      estimated_labour_amount: updateObj?.estimated_labour_amount || null,
      cushion_payout: updateObj?.cushion_payout || null,
      wo_triage_id: updateObj?.wo_triage_id || null,
      wo_original_install_date: updateObj?.wo_original_install_date || null,
      wo_wfp_eta: updateObj?.wo_wfp_eta || null,
      wo_original_cause_id: updateObj?.wo_original_cause_id || null,
      wo_explaination: updateObj?.wo_explaination || null,
      wo_reason_id: updateObj?.wo_reason_id || null,
      vendor_id: updateObj?.vendor_id || null,
      sos_po_vendor: updateObj?.sos_po_vendor || null,
      digital_detail_url:
        updateObj?.project_additional_fields?.digital_detail_url || null,
      project_color_config:
        typeof updateObj?.project_color_config === 'number'
          ? updateObj.project_color_config
          : null,
      workroom_id: updateObj?.workroom_id || null,
      special_tool: updateObj?.special_tool ? 1 : 0,
      property_occupation: updateObj?.property_occupation || 'Owner',
      refigure_reason_id: updateObj?.refigure_reason?.type_id || null,
      quote_total_retail: updateObj?.quote_total_retail,
      temp_install_quantity: updateObj?.temp_install_quantity ?? null,
      job_cancelled_date: updateObj?.job_cancelled_date ?? null,
      tag_ids: updateObj?.project_tag ?? [],
      custom_fields: updateObj?.customFields || {},
      site_id: updateObj?.project_additional_fields?.site_id || null,
      paid_date: updateObj?.paid_date,
    };
    if (updateObj?.quoteId) {
      updateObj = {
        ...updateObj,
        quote_id: updateObj?.quoteId,
      };
    }
    if (
      updateObj?.source_system?.source_system_id === SOURCE_SYSTEMS.LOWES &&
      updateObj?.project_type?.project_type_id === 2
    ) {
      updateRequestObj.dd_confirm = updateObj?.dd_confirm;
      updateRequestObj.dd_confirm_follow_up = updateObj?.dd_confirm_follow_up;
    }

    const response = await axios.patch(
      `${URL_CONSTANTS.API.BASE_URL}/projects/${projectId}`,
      updateRequestObj
    );
    if (response) {
      if (response?.data?.status) {
        history.push(
          `${redirectBasePath}?reportName=${updateObj?.status?.status}`
        );
        // setReloadForm(true);
        setAlert(
          'success',
          'Project has been updated successfully.',
          false,
          true
        );
        if (toast?.current) {
          toast.current?.show({
            severity: 'success',
            summary: 'Success',
            detail: 'Project has been updated successfully.',
            life: 3000,
          });
        }
      } else {
        setAlert('error', response?.data?.message);
      }
    }
    return response;
  } catch (error) {
    setAlert('error', error?.response?.data?.error);
    setLoading(false);
  }
};

// Get Customer Details like phone,email
export const getCustomerDetails = async (
  customerId,
  setLoading,
  setCustomerDetails,
  setFieldValue,
  setInstallationAddress,
  opportunityId = null,
  siteId = null
) => {
  try {
    // setLoading(true);
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/customers/${customerId}`
    );
    if (response) setCustomerDetails(response?.data);
    if (siteId) {
      const installationResponse = await axios.get(
        `${URL_CONSTANTS.API.BASE_URL}/system/address/${siteId}`
      );
      if (setFieldValue) {
        setFieldValue('customer', response?.data[0]);
        if (!opportunityId) {
          // setInstallationAddress(installationResponse?.data);
          setFieldValue('installation_address', installationResponse?.data);
        }
      }
    } else if (response?.data[0]?.billing_address_id) {
      const installationResponse = await axios.get(
        `${URL_CONSTANTS.API.BASE_URL}/system/address/${response?.data[0]?.billing_address_id}`
      );
      if (setFieldValue) {
        setFieldValue('customer', response?.data[0]);
        if (!opportunityId) {
          // setInstallationAddress(installationResponse?.data);
          setFieldValue('installation_address', installationResponse?.data);
        }
      }
    }

    return response;
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

export const getStoreDetails = async (
  projectId,
  setLoading,
  setStoreDetails
) => {
  try {
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/stores/reports/project-store-details/${projectId}`
    );
    setStoreDetails(response?.data);
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

export const updateProjectStatus = async (
  projectId,
  status,
  setReloadForm,
  setLoading,
  method = 'post'
) => {
  try {
    setLoading(true);

    const response = await axios({
      method,
      url: `${URL_CONSTANTS.API.BASE_URL}/projects/${projectId}/project-button-action/${status}`,
    });

    if (response) setReloadForm(true);
    return response;
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

export const createCompanyGroupInvoices = async (
  projectId,
  setLoading,
  method = 'post'
) => {
  try {
    setLoading(true);

    const response = await axios({
      method,
      url: `${URL_CONSTANTS.API.BASE_URL}/projects/${projectId}/project-installer-invoice/create`,
    });

    return response;
  } catch (error) {
    console.error(error);
  } finally {
    setLoading(false);
  }
};

export const updateWorkOrder = async (
  projectId,
  status,
  setReloadForm,
  setLoading
) => {
  try {
    setLoading(true);
    const response = await axios.patch(
      `${URL_CONSTANTS.API.BASE_URL}/projects/${projectId}/project-button-action/${status}`
    );
    if (response) setReloadForm(true);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const updateProjectContract = async (
  projectId,
  status,
  setReloadForm,
  setLoading
) => {
  try {
    setLoading(true);
    const response = await axios.post(
      `${URL_CONSTANTS.API.BASE_URL}/projects/${projectId}/status`,
      { status: status }
    );
    if (response) setReloadForm(true);
  } catch (error) {
    console.log(error);
  }
};
// Create New Project
export const addProject = async (
  addProjectObj,
  history,
  reportName,
  setLoading,
  setAlert,
  opportunityId,
  projectId,
  setProjectNumberExistError,
  module = null,
  toast = null
) => {
  try {
    setLoading(true);
    let addNewProject = {
      //Project Info fields
      total_sale_amount: addProjectObj?.total_sale_amount || null,
      source_system_id: addProjectObj?.source_system?.source_system_id,
      source_status_id: 27,
      confirmation_status_id: addProjectObj?.confirmation_status?.status_id,
      customer_id: addProjectObj?.customer?.customer_id,
      store_id: addProjectObj?.store_id,
      po_number: addProjectObj?.po_number || null,
      project_number: addProjectObj?.project_number || null,
      date_sold: addProjectObj?.date_sold || new Date(),
      status_id: addProjectObj?.status?.status_id || null,
      project_desc: addProjectObj?.project_desc?.trim() || null,
      project_type_id: addProjectObj?.project_type?.project_type_id,
      project_category_id: addProjectObj?.project_category_id,
      source_category_id: addProjectObj?.source_category_id,
      manage_as_project: addProjectObj?.manage_as_project,
      measure_to_install_conversion_rate:
        addProjectObj?.measure_to_install_conversion_rate ?? 0,
      referral_source_id: addProjectObj?.referral_source_id || null,
      related_measurer: addProjectObj?.related_measurer || null,
      ll_invoice_status: addProjectObj?.ll_invoice_status || null,
      ll_invoice_sent_date: addProjectObj?.ll_invoice_sent_date || null,
      estimated_labour_amount: addProjectObj?.estimated_labour_amount || null,
      cushion_payout: addProjectObj?.cushion_payout || null,
      digital_detail_url:
        addProjectObj?.project_additional_fields?.digital_detail_url || null,
      workroom_id: addProjectObj?.workroom_id || null,
      temp_install_quantity: addProjectObj?.temp_install_quantity ?? null,
      job_cancelled_date: addProjectObj?.job_cancelled_date ?? null,

      //Schedule Info fields
      reschedule_reason_id: addProjectObj?.reschedule_reason?.reason_id || null,
      date_scheduled_start: addProjectObj?.date_scheduled_start || null,
      date_scheduled_end: addProjectObj?.date_scheduled_end || null,
      completion_date: addProjectObj?.completion_date || null,
      windows: addProjectObj?.windows || null,
      rts_follow_up_date: addProjectObj?.rts_follow_up_date || null,
      pick_up_date: addProjectObj?.pick_up_date || null,
      pick_up_location_id: addProjectObj?.pick_up_location_id,
      primary_pick_up_location: addProjectObj?.primary_pick_up_location?.name
        ? addProjectObj?.primary_pick_up_location?.name
        : '',
      pick_up_location_reference_address_id:
        addProjectObj?.pick_up_location_reference_address_id,
      installation_address: [addProjectObj?.installation_address],
      open_in_provider_portal: addProjectObj?.open_in_provider_portal || null,
      installer_reference: addProjectObj?.installer_reference,
      meta: addProjectObj?.meta || {},
      scheduled_date_811: addProjectObj?.scheduled_date_811 || null,
      is_pull_permit_required: addProjectObj?.is_pull_permit_required ? 1 : 0,
      hd_category: addProjectObj?.hd_category || null,
      tier: addProjectObj?.tier || null,
      est_job_duration: addProjectObj?.est_job_duration?.toString() || null,
      year_built: addProjectObj?.year_built?.toString() || null,
      pickup_required: addProjectObj?.pickup_required || null,
      products: addProjectObj?.products === '' ? null : addProjectObj?.products,
      pick_up_location_address_id:
        addProjectObj?.pick_up_location_address_id || null,
      move_up_on_schedule:
        addProjectObj?.move_up_on_schedule === 1 ? true : false || false,
      scheduling_reason: addProjectObj?.scheduling_reason?.label
        ? addProjectObj?.scheduling_reason?.label
        : addProjectObj?.scheduling_reason || null,
      schedule_pending_reason: addProjectObj?.schedule_pending_reason?.label
        ? addProjectObj?.schedule_pending_reason?.label
        : addProjectObj?.schedule_pending_reason || null,
      eta_date: addProjectObj?.eta_date || null,
      vendor_id: addProjectObj?.vendor_id || null,
      sos_po_vendor: addProjectObj?.sos_po_vendor || null,
      project_color_config:
        typeof addProjectObj?.project_color_config === 'number'
          ? addProjectObj.project_color_config
          : null,
      special_tool: addProjectObj?.special_tool ? 1 : 0,
      refigure_reason_id: addProjectObj?.refigure_reason?.type_id,
      ...(addProjectObj?.existing_project_id
        ? { existing_project_id: addProjectObj?.existing_project_id }
        : {}),
      ...(addProjectObj?.existing_project_id
        ? { is_copied_line_item: addProjectObj?.is_copied_line_item }
        : {}),
      tag_ids: addProjectObj?.project_tag ?? [],
      copy_notes: addProjectObj?.copy_notes ? 1 : 0,
      copy_photos: addProjectObj?.copy_photos ? 1 : 0,
      copy_documents: addProjectObj?.copy_documents ? 1 : 0,
      ...(!addProjectObj?.is_copied_line_item ? { total_sale_amount: 0 } : {}),
      custom_fields: addProjectObj?.customFields || {},
      site_id: addProjectObj?.site_id || null,
      paid_date: addProjectObj?.paid_date,
    };
    let createUrl = `${URL_CONSTANTS.API.BASE_URL}/projects`;
    if (addProjectObj?.quoteId) {
      addNewProject = {
        ...addNewProject,
        quote_id: addProjectObj.quoteId,
        opportunity_number: addProjectObj.opportunity_number,
        quote_number: addProjectObj.quote_number,
        opportunity_id: opportunityId || null,
        quote_total_retail: addProjectObj?.quote_total_retail || 0,
      };

      createUrl = `${createUrl}?quoteId=${addProjectObj?.quoteId}`;
    }

    const response = await axios.post(createUrl, addNewProject);
    if (response && response?.data) {
      if (response.data?.status === false) {
        if (response.data?.message === PROJECT_NUMBER_API_ERROR_MSG)
          setProjectNumberExistError(true);
        else setAlert('error', response.data?.message, false, true);
      } else {
        if (toast?.current) {
          toast?.current?.show({
            severity: 'success',
            summary: 'Success',
            detail: 'New Project has been added successfully',
            life: 3000,
          });
        }
        if (addProjectObj?.quoteId) {
          putTurnOnTime(
            opportunityId,
            addProjectObj?.quoteId,
            response?.data?.project_id
          );
          const quoteDetails = getQuoteById(
            response.data?.client_id,
            opportunityId,
            addProjectObj?.quoteId
          );
          quoteDetails
            .then(async () => {
              if (opportunityId) {
                setTimeout(() => {
                  history.push(
                    `/crm/${addNewProject?.customer_id}/${opportunityId}/project/view/${
                      response.data?.project_id
                    }?reportName=${reportName || addProjectObj?.status?.status}`
                  );
                }, 1000);
              } else if (module === 'new') {
                setTimeout(() => {
                  history.push(
                    `/new-project/view/${response.data?.project_id}?reportName=${
                      reportName || addProjectObj?.status?.status
                    }`
                  );
                }, 1000);
              } else {
                setTimeout(() => {
                  history.push(
                    `/project/view/${response.data?.project_id}?reportName=${
                      reportName || addProjectObj?.status?.status
                    }`
                  );
                }, 1000);
              }
            })
            .catch(error => {
              if (error?.response?.status === 404) {
                return history.push('/page-not-found');
              }
              console.log('error', error?.response);
            });
        } else if (module === 'new') {
          setTimeout(() => {
            history.push(
              `/new-project/view/${response.data?.project_id}?reportName=${
                reportName || addProjectObj?.status?.status
              }`
            );
          }, 1000);
        } else {
          setTimeout(() => {
            history.push(
              `/project/view/${response.data?.project_id}?reportName=${
                reportName || addProjectObj?.status?.status
              }`
            );
          }, 1000);
        }
        setAlert(
          'success',
          'New Project has been added successfully',
          false,
          true
        );
      }
    }
    return response;
  } catch (error) {
    console.error(error);
    const errorMessage =
      error?.response?.data?.error || 'Error in Adding New Project';
    setAlert('error', errorMessage, false, true);
    if (toast?.current) {
      toast.current.show({
        severity: 'error',
        summary: 'Error',
        detail: errorMessage,
        life: 3000,
      });
    }
  } finally {
    setLoading(false);
  }
};

export const storeUpdateReadStatus = (noteId, type, userId) => {
  axios.patch(`${URL_CONSTANTS.API.BASE_URL}/projects/notes/store`, {
    noteId,
    type,
    userId,
  });
};

export const installerUpdateReadStatus = (noteId, type, userId) => {
  axios.patch(`${URL_CONSTANTS.API.BASE_URL}/projects/notes/installer`, {
    noteId,
    type,
    userId,
  });
};

export const customerNotesUpdateReadStatus = (noteId, type, userId) => {
  axios.patch(`${URL_CONSTANTS.API.BASE_URL}/projects/notes/customernotes`, {
    noteId,
    type,
    userId,
  });
};

//Add Notes
export const addBustedReason = async (
  projectId,
  values,
  setLoading,
  setAlert,
  setReloadList,
  setIsOpen,
  setRefereshLineItems
) => {
  setIsOpen(false);
  try {
    setLoading(true);
    setRefereshLineItems(true);
    const response = await axios.patch(
      `${URL_CONSTANTS.API.BASE_URL}/projects/${projectId}/project-button-action/busted`,
      values
    );
    if (response.data) setReloadList(true);
    setAlert('success', 'Busted Reason Added Successfully.', false, true);
  } catch (error) {
    console.error(error);
    setAlert('error', 'Error in Busted Reason.', false, true);
  } finally {
    setLoading(false);
    setRefereshLineItems(false);
  }
};
export const getProjectLeadDeclinedReasonOptions = async sourceId => {
  try {
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/system/reason?reasonType=lead_decline_reason&sourceSystemId=${sourceId}`
    );
    return response?.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

//Declied Lead Quick Action
export const declinedLeadAction = async (projectId, body) => {
  try {
    const response = await axios.patch(
      `${URL_CONSTANTS.API.BASE_URL}/projects/${projectId}/project-button-action/declined-lead`,
      body
    );
    return { status: true, data: response?.data };
  } catch (error) {
    return { status: false, message: error.message };
  }
};

//Ready To Schedule Quick Action
export const readyToScheduleQuickAction = async (projectId, values) => {
  try {
    const response = await axios.patch(
      `${CONFIG?.API_BASE_URL}/projects/${projectId}/project-button-action/ready-to-schedule`,
      values
    );
    return { status: true, data: response };
  } catch (error) {
    return { status: false, message: error.message };
  }
};

// Search User's
export const searchUserList = async searchString => {
  try {
    if (searchString) {
      const searchResponse = await apiService.get(
        `/auth/user/report/list?searchString=${searchString}&limit=20&offset=0`
      );
      return searchResponse?.items;
    } else {
      const userList = await apiService.get(
        `/auth/user/report/list?limit=20&offset=0`
      );
      return userList?.items;
    }
  } catch (error) {
    console.error(error);
  }
};

//Repair Order
export const repairOrderRecord = async projectId => {
  try {
    const response = await axios.patch(
      `${CONFIG?.API_BASE_URL}/projects/${projectId}/project-button-action/update-project-by-type`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

//Project Action Buttons
export const actionButton = async (projectId, actionType, payload) => {
  try {
    const response = await apiService.postWithDiffBaseUrl(
      `/projects/${projectId}/action/${actionType}`,
      payload,
      CONFIG?.API_PROJECT_URL
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

//GetProjectColors
export const getColorConfigList = async () => {
  try {
    const response = await apiService.get(`/admin-config/color-config/list`);
    return response;
  } catch (error) {
    console.error(error);
  }
};
//Get Workroom
export const getWorkRoom = async value => {
  try {
    const response = await apiService.get(
      `/system/workroom/list?searchString=${value}&limit=100&offset=0`
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getPersonalizedProjectNumber = async () => {
  try {
    const response = await apiService.get(
      `/projects/system/personalized-project-number`
    );
    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getGroupName = async () => {
  try {
    const response = await apiService.get(`/system/parent-category/list`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const groupTypes = async (value = null) => {
  try {
    const groupType = await apiService.get(`/master/group-name/${value}`);
    return groupType;
  } catch (error) {
    return error;
  }
};

export const getCustomerId = async projectId => {
  try {
    const projectDetailsRequest = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/projects/${projectId}`
    );
    return projectDetailsRequest;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const getCustomerChatsNotifications = async (offset, limit) => {
  return await axios.get(
    `${URL_CONSTANTS.API.BASE_URL}/projects/notes/customer?offset=${offset}&limit=${limit}`
  );
};
export const customerChatReviewRead = async (noteId, type, userId) => {
  try {
    await axios.post(
      `${URL_CONSTANTS.API.BASE_URL}/projects/notes/customer/${noteId}/${type}`,
      {
        userId,
        type: 'customer',
      }
    );
  } catch (error) {
    console.log('Review customer Error', error);
  }
};
export const customerChatUpdateReadStatus = (noteId, type, userId) => {
  axios.patch(`${URL_CONSTANTS.API.BASE_URL}/projects/notes/customer`, {
    noteId,
    type,
    userId,
  });
};
export const getRefigureReason = async () => {
  try {
    const response = await axios.get(
      `${URL_CONSTANTS.API.BASE_URL}/admin-config/get-refigure-reason`
    );
    return response?.data?.data || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
export const addProjectTag = async payload => {
  const response = await axios.post(
    `${URL_CONSTANTS?.API?.BASE_URL}/system/types/project_tag`,
    payload
  );
  return response.data;
};

export const getProjectTags = async (search, params) => {
  if (typeof params === 'object' && !Array.isArray(params)) {
    params = { ...params, ...(search ? { search } : {}) };
  } else {
    params = search ? { search } : {};
  }
  const response = await axios.get(
    `${URL_CONSTANTS?.API?.BASE_URL}/system/types/project_tag`,
    {
      params,
    }
  );
  return response.data;
};

export const getProjectActionButtons = async projectId => {
  const response = await axios.get(
    `${URL_CONSTANTS?.API?.BASE_URL}/projects/${projectId}/project-action-button`
  );
  return response.data;
};

export const actionButtonsScheduledMessage = async (payload, projectId) => {
  const response = await axios.post(
    `${URL_CONSTANTS?.API?.BASE_URL}/projects/${projectId}/sms/scheduledMessage`,
    payload
  );
  return response.data;
};

export const addNote = async (payload, projectId) => {
  const response = await axios.post(
    `${URL_CONSTANTS?.API?.BASE_URL}/projects/${projectId}/notes`,
    payload
  );
  return response;
};
export const updateFields = async (payload, projectId) => {
  const response = await axios.post(
    `${URL_CONSTANTS?.API?.BASE_URL}/projects/${projectId}/action-button/update-fields`,
    payload
  );
  return response;
};

export const sendRecurrenceConfigData = async payload => {
  try {
    const postRecurrenceDataResponse = await apiService.postWithDiffBaseUrl(
      apiService.formatUrl(
        URL_CONSTANTS?.RECURRENCE?.postRecurrenceRruleConfigData,
        payload?.source_project_id
      ),
      payload,
      URL_CONSTANTS?.API?.BASE_URL
    );

    return {
      error: false,
      data: postRecurrenceDataResponse,
      message: 'Data Saved ',
    };
  } catch (error) {
    return {
      error: true,
      message: error,
      data: {},
    };
  }
};

export const getRecurrenceGenerationStatus = async recurringEventId => {
  const response = await apiService.getWithDiffBaseUrl(
    apiService.formatUrl(
      URL_CONSTANTS?.RECURRENCE?.getRecurrenceGeneration,
      recurringEventId
    ),
    {},
    URL_CONSTANTS?.API?.BASE_URL
  );

  return response?.data;
};

export const updateRecurringEvent = async payload => {
  try {
    const updateRecurringEventResponse = await apiService.patchWithDiffBaseUrl(
      apiService.formatUrl(
        URL_CONSTANTS?.RECURRENCE?.updateRecurringEvent,
        payload?.recurring_event_id
      ),
      payload,
      URL_CONSTANTS?.API?.BASE_URL
    );

    return {
      error: false,
      data: updateRecurringEventResponse,
      message: 'Recurring event updated successfully.',
    };
  } catch (error) {
    return {
      error: true,
      message: error,
      data: {},
    };
  }
};

export const updateRecurrenceEventProject = async ({
  recurring_event_id,
  project_id,
  action,
}) => {
  try {
    const response = await apiService.postWithDiffBaseUrl(
      apiService.formatUrl(
        URL_CONSTANTS.RECURRENCE.updateRecurringProject,
        recurring_event_id,
        project_id
      ),
      {
        action: action,
      },
      URL_CONSTANTS.API.BASE_URL
    );

    return {
      error: false,
      data: response,
      message: 'Recurring project updated successfully.',
    };
  } catch (error) {
    return {
      error: true,
      message: error,
      data: {},
    };
  }
};
